var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var useFocusError = function () {
    var scrollToFirstError = function (props) {
        var _a = props !== null && props !== void 0 ? props : {}, targetClass = _a.targetClass, scrollOptions = _a.scrollOptions;
        var classNameToRead = targetClass !== null && targetClass !== void 0 ? targetClass : 'Mui-error';
        setTimeout(function () {
            var errorFields = document === null || document === void 0 ? void 0 : document.getElementsByClassName(classNameToRead);
            var firstErrorField = errorFields === null || errorFields === void 0 ? void 0 : errorFields[0];
            var parentOfFirstError = firstErrorField === null || firstErrorField === void 0 ? void 0 : firstErrorField.parentElement;
            parentOfFirstError === null || parentOfFirstError === void 0 ? void 0 : parentOfFirstError.scrollIntoView(__assign({ behavior: 'smooth', block: 'center' }, (scrollOptions !== null && scrollOptions !== void 0 ? scrollOptions : {})));
        }, 100);
    };
    return { scrollToFirstError: scrollToFirstError };
};
//# sourceMappingURL=useFocusError.js.map